<dx-box direction="col" height="100%" width="100%" *ngIf="visible" align="center" crossAlign="center">
    <dxi-item [ratio]="1">
        <webcam
            [allowCameraSwitch]="allowCameraSwitch"
            [videoOptions]="videoOptions"
            [imageQuality]="1"
            [trigger]="triggerObservable"
            [switchCamera]="nextWebcamObservable"
            (imageCapture)="handleImage($event)"
            (cameraSwitched)="handleCameraSwitched($event)"
            (initError)="handleInitError($event)"
        ></webcam>
    </dxi-item>
    <dxi-item baseSize="auto">
        <dx-toolbar>
            <dxi-item
                *ngIf="multipleWebCamsAvailable"
                location="center"
                widget="dxButton"
                [options]="{
                    icon: 'refresh',
                    stylingMode: 'contained',
                    hint: 'Switch camera',
                    onClick: switchCamera
                }"
            ></dxi-item>
            <dxi-item
                location="center"
                widget="dxButton"
                [options]="{
                    icon: 'isnotblank',
                    stylingMode: 'contained',
                    hint: 'Take picture',
                    onClick: clickCamera
                }"
            ></dxi-item>
            <dxi-item
                location="center"
                widget="dxButton"
                [options]="{
                    icon: 'clear',
                    stylingMode: 'contained',
                    hint: 'Close',
                    onClick: switchOffCamera
                }"
            ></dxi-item>
        </dx-toolbar>
    </dxi-item>
</dx-box>
